import { Box } from 'core/components';
import styled, { css } from 'styled-components';

export const markdownCodeStyles = css`
  code {
    background-color: ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(110, 118, 129, 0.4)' : 'rgba(175, 184, 193, 0.2)'};
    border-radius: 6px;
    padding: 2px 6px;
    font-size: 85%;
    font-family:
      ui-monospace,
      SFMono-Regular,
      SF Mono,
      Menlo,
      Consolas,
      Liberation Mono,
      monospace;
    color: ${({ theme }) => (theme.name === 'dark' ? '#58a6ff' : '#0969da')};
  }
`;

const codeMirrorBaseStyles = css`
  .react-codemirror2,
  .CodeMirror {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    background-color: transparent;
  }

  .CodeMirror {
    color: ${({ theme }) => (theme.name === 'dark' ? '#c9d1d9' : '#e0e0e0')};
  }

  .CodeMirror-scroll {
    overflow: auto;
  }

  .CodeMirror-gutters {
    background-color: transparent;
    color: ${({ theme }) => (theme.name === 'dark' ? '#6E6E6E' : '#537F7E')};
    border: none;
  }

  .cm-header {
    color: #58a6ff !important;
    font-weight: 600 !important;
  }
  .cm-strong {
    color: inherit !important;
    font-weight: 600 !important;
  }
  .cm-em {
    color: inherit !important;
    font-style: italic !important;
  }
  .cm-link,
  .cm-url {
    color: #58a6ff !important;
    text-decoration: underline !important;
  }
  .cm-variable-2,
  .cm-variable-3 {
    color: #d2a8ff !important;
  }
  .cm-comment,
  .cm-quote {
    color: #8b949e !important;
    font-style: italic !important;
  }
  .cm-string {
    color: #a5d6ff !important;
  }
`;

export const CodeViewerContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.gray3};
  border-radius: 4px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: ${({ $minHeight }) => $minHeight || '150px'};
  ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight};` : '')}
  background-color: ${({ theme }) => (theme.name === 'dark' ? '#0d1117' : '#263238')};

  ${codeMirrorBaseStyles}
`;
